/* eslint-disable jsx-a11y/anchor-is-valid */
import dayjs from "dayjs"
import {observer} from "mobx-react"
import {useRef} from "react"
import {Map, MapMarker} from "react-kakao-maps-sdk"
import {VerticalTimeline, VerticalTimelineElement} from "react-vertical-timeline-component"
import {AlertDialogBox} from "common/AlertDialogBox"
import {DialogBoxBody, DialogBoxProps} from "common/DialogBox"
import {RealDevice} from "dto/realdevice/devices"
import {HidingConditionKey} from "store/dashboard/DashboardStore"
import {useRootStore} from "store/useRootStore"

interface ImpactAlarmWindowProps extends DialogBoxProps {
    devices: RealDevice[]
}

export const ImpactAlarmWindow = ({show, close, devices}: ImpactAlarmWindowProps) => {
    if (!show || devices.length === 0) return null
    return <ImpactAlarmWindowBody show={show} close={close} devices={devices}/>
}
const ImpactAlarmWindowBody = observer(({show, close, devices}: ImpactAlarmWindowProps) => {
    const {dashboardStore: {setHideConditionForEmergencyDevice}} = useRootStore()
    const audioRef = useRef<HTMLAudioElement>(null)
    const hideAlarm = (eui: string, key: HidingConditionKey) => {
        if (!window.confirm("해당 시간 동안 알람을 중지하시겠습니까?")) return
        setHideConditionForEmergencyDevice(eui, key)
    }
    return (
        <AlertDialogBox show={!!show} close={close} title="넘어짐 감지 알림" color="danger">
            {/*<iframe src="/sound/silence.mp3" allow="autoplay" style={{display: 'none'}}/>*/}
            <audio autoPlay ref={audioRef} loop preload="auto">
                <source src="/sound/alarm.wav"/>
            </audio>
            <DialogBoxBody>
                <VerticalTimeline lineColor={"black"} layout="1-column"
                                  className="has-background-white-bis">
                    {devices.map(device => {
                        const date = dayjs(device.communicationDevice.lastCommunicationTime).format("YYYY/MM/DD HH:mm:ss") || ""
                        const currentLatLng = device.communicationDevice.currentLatLng
                        const latLng = currentLatLng ? {
                            lat: parseFloat(device.communicationDevice.currentLatLng?.lat || "0"),
                            lng: parseFloat(device.communicationDevice.currentLatLng?.lng || "0"),
                        } : null
                        const eui = device.communicationDevice.eui
                        return (
                            <VerticalTimelineElement
                                key={device.id}
                                // className="vertical-timeline-element--work"
                                contentStyle={{background: bgColor, color: fontColor}}
                                contentArrowStyle={{borderRight: `7px solid  ${bgColor}`}}
                                // date={date}
                                iconStyle={{background: iconBgColor, color: iconFontColor}}
                                icon={Icon}>
                                <div className="card">
                                    <div className="card-image">
                                        <div className="columns pl-5">
                                            <p className="is-size-6 has-text-black">장비 ID</p>
                                            <p className="ml-5 has-text-info-dark">{device.communicationDevice.eui}</p>
                                            <p className="is-size-6 has-text-black ml-auto">발생시간</p>
                                            <p className="ml-5 mr-5 has-text-info-dark">{date}</p>
                                        </div>
                                        <figure className="is-4by3" style={{position: 'relative', height: 300}}>
                                            {latLng && (
                                                <Map center={latLng}
                                                     onCreate={map => setTimeout(() => {
                                                         map.relayout()
                                                         map.panTo(
                                                             new kakao.maps.LatLng(
                                                                 latLng?.lat,
                                                                 latLng?.lng
                                                             ))
                                                     }, 200)}
                                                     style={{
                                                         position: "absolute",
                                                         top: 0,
                                                         right: 0,
                                                         bottom: 0,
                                                         left: 0,
                                                         height: 300,
                                                     }}>
                                                    <MapMarker position={latLng}/>
                                                </Map>
                                            )}

                                        </figure>
                                    </div>
                                    <div className="card-content">
                                        <div className="media">
                                            <div className="media-left">
                                                <div style={{borderRadius: 30, height: 48, width: 48}}
                                                     className="has-background-primary mt-2">
                                                    <div className="icon ml-4 mt-4 "><i
                                                        className="fas fa-phone-flip has-text-white"
                                                        style={{fontSize: 30}}/></div>
                                                </div>
                                            </div>
                                            <div className="media-content">
                                                <p className="title is-4"
                                                   style={{marginTop: 0}}>
                                                    {device.name} {/*<span className="is-size-6 ml-3 has-text-link-dark">[{device.communicationDevice.eui}]</span>*/}
                                                </p>
                                                <p className="subtitle is-6 ">전화번호
                                                    <span className="has-text-info ml-1" style={{fontSize: 20}}>
                                                        {device.mobile?.phoneNumber}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="media-content">
                                                <p className="title is-4"
                                                   style={{marginTop: 0}}>
                                                    {device.protector?.name} {/*<span className="is-size-6 ml-3 has-text-link-dark">[{device.communicationDevice.eui}]</span>*/}
                                                </p>
                                                <p className="subtitle is-6 ">전화번호
                                                    <span className="has-text-info ml-1" style={{fontSize: 20}}>
                                                        {device.protector?.mobile}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="media">
                                            <div className="media-left">
                                                <div style={{borderRadius: 30, height: 48, width: 48}}
                                                     className="has-background-primary mt-2">
                                                    <div className="icon ml-4 mt-4 "><i
                                                        className="fas fa-map-location has-text-white"
                                                        style={{fontSize: 30}}/></div>
                                                </div>
                                            </div>
                                            <div className="media-content">
                                                <p className="title is-5 has-text-danger-dark" style={{marginTop: 0}}>
                                                    넘어짐 발생 위치 </p>
                                                <p className="subtitle is-6 ">
                                                    <span>위도 <span
                                                        className="has-text-primary-dark ml-1">{device.communicationDevice.currentLatLng?.lat}</span></span>
                                                    <span className="ml-3">경도 <span
                                                        className="has-text-primary-dark ml-1">{device.communicationDevice.currentLatLng?.lng}</span></span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="media">
                                            <div className="media-content has-text-right">
                                                <div className="has-text-danger-dark">알람을 중지하고 싶을 경우 아래 시간을 선택 하세요</div>
                                                <DelayButton name="5분" onClick={() => hideAlarm(eui, "5m")}/>
                                                <DelayButton name="10분" onClick={() => hideAlarm(eui, "10m")}/>
                                                <DelayButton name="20분" onClick={() => hideAlarm(eui, "20m")}/>
                                                <DelayButton name="30분" onClick={() => hideAlarm(eui, "30m")}/>
                                                <DelayButton name="1시간" isHour={true}
                                                             onClick={() => hideAlarm(eui, "1h")}/>
                                                <DelayButton name="2시간" isHour={true}
                                                             onClick={() => hideAlarm(eui, "2h")}/>
                                                <DelayButton name="4시간" isHour={true}
                                                             onClick={() => hideAlarm(eui, "4h")}/>
                                                <DelayButton name="8시간" isHour={true}
                                                             onClick={() => hideAlarm(eui, "8h")}/>
                                                <DelayButton name="12시간" isHour={true}
                                                             onClick={() => hideAlarm(eui, "12h")}/>
                                                <DelayButton name="24시간" isHour={true}
                                                             onClick={() => hideAlarm(eui, "24h")}/>

                                            </div>
                                        </div>
                                        <div className="content">
                                            <a>현재 운행중인 휠체어에서 넘어짐이 감지 되었습니다.</a> <a>빠른 조치 바랍니다.</a>
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </VerticalTimelineElement>
                        )
                    })}

                </VerticalTimeline>
            </DialogBoxBody>
        </AlertDialogBox>
    )
})

const Icon = <span className="icon is-large" style={{fontSize: 25}}> <i
    className="fas fa-warning has-text-warning is-large"/> </span>

const DelayButton = ({onClick, name, isHour}: { name: string, onClick?: () => void, isHour?: boolean }) => {
    return (
        <button
            onClick={() => {
                if (onClick) onClick()
            }}
            className={`button is-rounded is-small has-text-white ${isHour ? "has-background-link " : "has-background-primary"}`}> {name}
        </button>
    )
}

const bgColor = "white"
const fontColor = "black"
const iconFontColor = "hsl(0, 0%, 21%)"
const iconBgColor = "red"
